import { render } from "./PopupVerify2FA.vue?vue&type=template&id=a45eb210&scoped=true"
import script from "./PopupVerify2FA.vue?vue&type=script&lang=js"
export * from "./PopupVerify2FA.vue?vue&type=script&lang=js"

import "./PopupVerify2FA.vue?vue&type=style&index=0&id=a45eb210&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a45eb210"]])

export default __exports__